import { useMutation } from '@tanstack/react-query';

import { parseApiError } from '@cast/api-client';
import { client } from '@cast/core';
import { notify } from '@cast/design-system';

type DeleteStepFixturesInput = {
  fixturesGroup: string;
  tourStep: string;
};

export const useDeleteStepFixturesMutation = () => {
  return useMutation({
    mutationFn: async ({
      fixturesGroup,
      tourStep,
    }: DeleteStepFixturesInput) => {
      return client.delete(`/dev-tools/recorder/${fixturesGroup}`, {
        data: { tourStep },
        baseURL: '',
      });
    },
    onSuccess: () => {
      notify.success('Static fixtures deleted successfully!');
    },
    onError: (error) => {
      notify.error(parseApiError(error));
    },
  });
};
